exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DateRangePicker .DateRangePickerInput{border-radius:9px;overflow:auto;border:1px solid #B2BEC3}.DateRangePicker .DateInput{overflow:hidden}.DateRangePicker .DateInput_input{border-bottom:none;font-size:15px}.DateRangePicker .input-icon{position:absolute;right:45px;width:15px;height:15px;border-radius:50%;bottom:calc(50% - 8px)}.DateRangePicker .input-icon.error{color:#EB6878 !important}.DateRangePicker .input-icon.success{color:#06bced !important}.DateRangePicker .input-icon.remove{color:#b7c7d2 !important}\n", ""]);

// exports
